import React from 'react';
import { AuthProvider } from '../contexts/AuthContext';

export function AppProviders({
  children,
  azureAuthEnabled,
}: {
  children: React.ReactNode;
  azureAuthEnabled: boolean;
}): React.ReactElement {
  return (
    <AuthProvider azureAuthEnabled={azureAuthEnabled}>{children}</AuthProvider>
  );
}
